import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalJobsService } from "services/ClientPortalJobsService";
import { ClientPortalJobDetailsModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  Job: new ClientPortalJobDetailsModel(),
  Loading: false,
};

export const JobDetailsSlice = createSlice({
  name: "JobDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getJobFromJobID.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getJobFromJobID.fulfilled, (state, action) => {
        state.Job = action.payload;
        state.Loading = false;
      })
      .addCase(getJobFromJobID.rejected, (state) => {
        state.Job = new ClientPortalJobDetailsModel();
        state.Loading = false;
      })
      .addCase(getJobFromEstimateRequestID.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getJobFromEstimateRequestID.fulfilled, (state, action) => {
        state.Job = action.payload;
        state.Loading = false;
      })
      .addCase(getJobFromEstimateRequestID.rejected, (state) => {
        state.Job = new ClientPortalJobDetailsModel();
        state.Loading = false;
      });
  },
});

export const getJobFromJobID = createAsyncThunk<ClientPortalJobDetailsModel, { jobID: number; taskSeqNo: number }>(
  "JobDetails/GetJobFromJobID",
  async ({ jobID, taskSeqNo }) => {
    const jobsService = container.get<IClientPortalJobsService>(SERVICE_TYPES.ClientPortalJobsService);
    return await jobsService.getJobFromJobID(jobID, taskSeqNo);
  }
);

export const getJobFromEstimateRequestID = createAsyncThunk<ClientPortalJobDetailsModel, { estimateRequestID: string }>(
  "JobDetails/GetJobFromEstimateRequestID",
  async ({ estimateRequestID }) => {
    const jobsService = container.get<IClientPortalJobsService>(SERVICE_TYPES.ClientPortalJobsService);
    return await jobsService.getJobFromEstimateRequestID(estimateRequestID);
  }
);

export const selectJob = (state: RootState) => state.jobDetails.Job;
export const selectLoadingJob = (state: RootState) => state.jobDetails.Loading;

export default JobDetailsSlice.reducer;
